export const userManagementAPIRoutes = {
  baseUrl: process.env.REACT_APP_USER_MANAGEMENT_API_URL,
  login: {
    endpoint: 'login'
  },
  logout: {
    endpoint: 'logout'
  },
  users: {
    endpoint: 'users',
    findUsersByCategory: 'findUsersByCategory',
    forgotPassword: 'forgotPassword',
    resetPassword: 'resetPassword',
    saveVendor: 'saveVendor'
  },
  roles: {
    endpoint: 'roles',
    getAllRoleBySearchCriteria: 'getAllRoleBySearchCriteria'
  },
  permissions: {
    endpoint: 'permissions',
    saveRolePermissionMapping: 'saveRolePermissionMapping'
  },
  enums: {
    endpoint: 'enums',
    saveEnumData: 'enums',
    updateEnumData: 'enums',
    getEnumDataBySearchCriteria: 'enums/getEnumDataBySearchCriteria',
    getEnumDataById: 'enums',
    deleteEnumDataById: 'delete'
  },
  otpController: {
    endpoint: 'signUp',
    sendOtp: 'sendOtp',
    verifyOtp: 'verifyOtp'
  }
};
